export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_01.7bbf2c87.jpg";